"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.integerValues = integerValues;
exports.filter = filter;
const property_1 = require("@genesys/property");
/**
 * The values of a discrete property, 0..count-1, none of them filtered. Every discrete property
 * in this tool is a plain enum whose labels come from the translation database, so the list is
 * the same shape every time and only its length differs.
 */
function integerValues(count) {
    return Array.from({ length: count }, (_unused, i) => ({
        sort_no: i,
        value: { type: "integer", value: i },
        property_filter: property_1.PropertyFilter.Empty
    }));
}
function filter(text) {
    return property_1.PropertyFilter.fromString(text);
}
//# sourceMappingURL=values.js.map